import { MAX_SMITHERS_BULK_DEVICES } from "@/types/smithers-device"

export function validateSmithersBulkDeviceIds(ids: readonly number[]): void {
  if (ids.length < 1 || ids.length > MAX_SMITHERS_BULK_DEVICES) {
    throw new Error(`ids must contain between 1 and ${MAX_SMITHERS_BULK_DEVICES} entries`)
  }
  if (ids.some((id) => !Number.isSafeInteger(id) || id <= 0)) throw new Error("Device IDs must be positive integers")
  if (new Set(ids).size !== ids.length) throw new Error("Device IDs must be unique")
}

export function getSmithersPageAfterBulkDelete(page: number, total: number, deleted: number, pageSize = 50): number {
  return Math.min(page, Math.max(1, Math.ceil(Math.max(0, total - deleted) / pageSize)))
}
